<template>
  <div
    class="layout__component-container-wrap layout__component-container-wrap--dark"
  >
    <!-- timers / archive select -->
    <nav
      aria-label="Timer table"
      class="dashboard__table-nav-wrap layout__component-container layout__component-container--dark"
    >
      <div
        class="dashboard__sort-wrap layout--flex-space-between layout--margin-bottom-sm"
      >
        <ul class="dashboard__table-nav">
          <li class="dashboard__table-nav-item">
            <router-link
              :to="{
                name: 'dashboard overview',
                query: getRouterQuery({ timerType: 'timers' }),
              }"
              class="dashboard__table-nav-link"
              :class="{
                'dashboard__table-nav-link--active': timerType === 'timers',
              }"
            >
              Timers
              <span class="dashboard__table-count">{{ activeTimerCount }}</span>
            </router-link>
          </li>
          <li class="dashboard__table-nav-item">
            <router-link
              :to="{
                name: 'dashboard overview',
                query: getRouterQuery({ timerType: 'archive' }),
              }"
              class="dashboard__table-nav-link"
              :class="{
                'dashboard__table-nav-link--active': timerType === 'archive',
              }"
            >
              Archive
              <span class="dashboard__table-count">{{
                archivedTimerCount
              }}</span>
            </router-link>
          </li>
        </ul>
        <ul class="dashboard__table-nav">
          <li class="dashboard__table-nav-item layout--hide-mobile">View</li>
          <li class="dashboard__table-nav-item">
            <router-link
              :to="{
                name: 'dashboard overview',
                query: getRouterQuery({
                  viewType: 'gallery',
                  numberOfTimers: defaultValues.defaultNumberOfTimers,
                }),
              }"
              class="dashboard__table-nav-link-icon"
              :class="{
                'dashboard__table-nav-link-icon--active':
                  viewType === 'gallery',
              }"
            >
              <IconViewGrid class="icon" style="vertical-align: -0.1em;" /><span
                class="sr-only"
                >Gallery</span
              ></router-link
            >
          </li>
          <li class="dashboard__table-nav-item">
            <router-link
              :to="{
                name: 'dashboard overview',
                query: getRouterQuery({ viewType: 'list' }),
              }"
              class="dashboard__table-nav-link-icon"
              :class="{
                'dashboard__table-nav-link-icon--active': viewType === 'list',
              }"
              ><IconViewList class="icon" /><span class="sr-only"
                >List</span
              ></router-link
            >
          </li>
        </ul>
      </div>
      <div
        class="dashboard__sort-wrap layout--flex-start input-group__wrap input-group__wrap--wide"
      >
        <div
          class="input-group__select-wrap input-group__select-wrap--small input-group__select-wrap--left"
          :class="{ 'layout--hide': viewType === 'gallery' }"
        >
          <label for="number-of-timers" class="layout--screen-reader-only"
            >Number of Timers</label
          >
          <select
            id="number-of-timers"
            class="input-group__select input-group__select--small"
            v-model="numberOfTimers"
            v-if="viewType === 'gallery'"
            ><option :value="9">Show: 9</option></select
          >
          <select
            id="number-of-timers"
            class="input-group__select input-group__select--small"
            v-model="numberOfTimers"
            v-if="viewType === 'list'"
            ><option
              v-for="numberPerPage in numberPerPageOptions"
              :key="numberPerPage.value"
              :value="numberPerPage.value"
              >Show: {{ numberPerPage.label }}</option
            ></select
          >
        </div>
        <div
          class="input-group__select-wrap input-group__select-wrap--small input-group__select-wrap--left layout--margin-bottom-sm"
        >
          <label for="sort-table" class="layout--screen-reader-only"
            >Sort Table</label
          >
          <select
            id="sort-table"
            v-model="sortSelected"
            class="input-group__select input-group__select--small"
            ><option
              v-for="sortOption in sortOptions"
              :key="sortOption.value"
              :value="sortOption.value"
              >Sort: {{ sortOption.value }}</option
            ></select
          >
        </div>
        <div class="input-group__input-wrap input-group__input-wrap--search">
          <label for="search-table" class="layout--screen-reader-only"
            >Search Table</label
          >
          <input
            id="search-table"
            class="input-group__input input-group__input--search input-group__input--light"
            type="text"
            v-model="searchValue"
            placeholder="Search"
          />
        </div>
      </div>
    </nav>
    <Gallery
      :timerList="timersToDisplay"
      v-if="viewType === 'gallery' || timers.length === 0"
      @open-timer-code-modal="openTimerCodeModal(params)"
      :empty="timersToDisplay.length === 0"
    />
    <List
      :timerList="timersToDisplay"
      v-if="(viewType !== 'gallery') & (timers.length > 0)"
    />
    <nav aria-label="Timer table page" v-if="timers.length > 0">
      <ul
        class="dashboard__table-nav dashboard__table-nav--margin dashboard__table-nav--paginate layout__component-container layout--flex-wrap layout--padding-top-md"
      >
        <li
          class="dashboard__table-nav-item dashboard__table-nav-item--showing"
        >
          Showing {{ firstTimerOnPage }} to {{ lastTimerOnPage }} of
          {{ sortTimers.length }}
        </li>
        <li class="dashboard__table-nav-item">
          <button
            class="button button--secondary"
            type="button"
            @click="previousPage"
          >
            Previous
          </button>
        </li>
        <li class="dashboard__table-nav-item">
          <button
            class="button button--secondary"
            type="button"
            @click="nextPage"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import IconViewGrid from "../../../assets/icons/iconView-Grid.svg";
import IconViewList from "../../../assets/icons/iconView-List.svg";

import Gallery from "./table/Gallery";
import List from "./table/List";
import TimerCode from "../../../components/TimerCode";

export default {
  name: "header-overview-table",
  components: { Gallery, IconViewGrid, IconViewList, List },
  data() {
    return {
      defaultValues: {
        defaultTimerType: "timers",
        defaultViewType: "gallery",
        defaultSortBy: "end date",
        defaultSortDirection: "ascending",
        defaultNumberOfTimers: 9,
      },
      sortOptions: [
        {
          value: "End Date (Newest to Oldest)",
          sortBy: "end date",
          sortDirection: "descending",
        },
        {
          value: "End Date (Oldest to Newest)",
          sortBy: "end date",
          sortDirection: "ascending",
        },
        /* {
          value: "Impressions (Most)",
          sortBy: "impressions",
          sortDirection: "descending",
        },
        {
          value: "Impressions (Least)",
          sortBy: "impressions",
          sortDirection: "ascending",
        }, */
        {
          value: "Name (A-Z)",
          sortBy: "name",
          sortDirection: "descending",
        },
        {
          value: "Name (Z-A)",
          sortBy: "name",
          sortDirection: "ascending",
        },
        {
          value: "Time Zone (A-Z)",
          sortBy: "time zone",
          sortDirection: "descending",
        },
        {
          value: "Time Zone (Z-A)",
          sortBy: "time zone",
          sortDirection: "ascending",
        },
      ],
      numberPerPageOptions: [
        { value: 9, label: "9" },
        { value: 18, label: "18" },
        { value: 36, label: "36" },
        { value: 0, label: "All" },
      ],
    };
  },
  mounted() {
    const sortOption = this.sortOptions.find(
      o => o.value === this.timerSortSelected
    );
    this.defaultValues.defaultSortBy = sortOption.sortBy;
    this.defaultValues.defaultSortDirection = sortOption.sortDirection;
  },
  watch: {
    searchValue: function(val) {
      if (val !== "") this.pageNumber = 1;
    },
  },
  computed: {
    ...mapGetters("timers", ["timers"]),
    ...mapGetters("account", ["timerSortSelected"]),
    // return timerType from router query or the default
    timerType: function() {
      if (this.$route.query.timerType) {
        return this.$route.query.timerType;
      }
      return this.defaultValues.defaultTimerType;
    },
    // return viewType from router query or the default
    viewType: function() {
      if (this.$route.query.viewType) {
        return this.$route.query.viewType;
      }
      return this.defaultValues.defaultViewType;
    },
    // return sortBy from router query or the default
    sortBy: function() {
      if (this.$route.query.sortBy) {
        return this.$route.query.sortBy;
      }
      return this.defaultValues.defaultSortBy;
    },
    // return sortDirection from router query or the default
    sortDirection: function() {
      if (this.$route.query.sortDirection) {
        return this.$route.query.sortDirection;
      }
      return this.defaultValues.defaultSortDirection;
    },
    activeTimers: function() {
      return this.timers.filter(w => w.widget.archived === false);
    },
    archivedTimers: function() {
      return this.timers.filter(w => w.widget.archived === true);
    },
    // filter timers by archived or not archived
    statusFilterTimers: function() {
      if (this.timerType === "timers") {
        return this.activeTimers;
      }
      if (this.timerType === "archive") {
        return this.archivedTimers;
      }
      return this.timers;
    },
    activeTimerCount() {
      return this.activeTimers.length;
    },
    archivedTimerCount() {
      return this.archivedTimers.length;
    },
    // return timers list filtered by the user's search term based on widget name
    searchFilterTimers: function() {
      if (this.searchValue !== "") {
        return this.statusFilterTimers.filter(w => {
          if (
            w.widget.name.toLowerCase().includes(this.searchValue.toLowerCase())
          ) {
            return true;
          }
          if (
            w.endDateTimeZoneFormatted
              .toLowerCase()
              .includes(this.searchValue.toLowerCase())
          ) {
            return true;
          }
          if (
            w.apiUrl &&
            w.apiUrl.match(/[a-zA-Z0-9]+$/) &&
            w.apiUrl.match(/[a-zA-Z0-9]+$/)[0].includes(this.searchValue)
          ) {
            return true;
          }
          return false;
        });
      }
      return this.statusFilterTimers;
    },
    // sort timers by a specific criteria and direction
    sortTimers: function() {
      if (this.sortBy === "impressions") {
        if (this.sortDirection === "ascending") {
          return this.searchFilterTimers.sort(
            (a, b) => a.impressionCount - b.impressionCount
          );
        }
        return this.searchFilterTimers.sort(
          (a, b) => b.impressionCount - a.impressionCount
        );
      }
      if (this.sortBy === "name") {
        if (this.sortDirection === "ascending") {
          return this.searchFilterTimers.sort((a, b) => {
            if (a.widget.name.toLowerCase() > b.widget.name.toLowerCase()) {
              return -1;
            }
            if (a.widget.name.toLowerCase() < b.widget.name.toLowerCase()) {
              return 1;
            }
            return 0;
          });
        }
        return this.searchFilterTimers.sort((a, b) => {
          if (a.widget.name.toLowerCase() < b.widget.name.toLowerCase()) {
            return -1;
          }
          if (a.widget.name.toLowerCase() > b.widget.name.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      }
      if (this.sortBy === "end date") {
        if (this.sortDirection === "ascending") {
          return this.searchFilterTimers.sort((a, b) => {
            const [
              aYear,
              aMonth,
              aDay,
              aHour,
              aMinute,
              aSecond,
            ] = a.widget.endDateTime.split(/[-,T,:]+/);
            const [
              bYear,
              bMonth,
              bDay,
              bHour,
              bMinute,
              bSecond,
            ] = b.widget.endDateTime.split(/[-,T,:]+/);
            const aDate = new Date(
              aYear,
              aMonth,
              aDay,
              aHour,
              aMinute,
              aSecond
            );
            const bDate = new Date(
              bYear,
              bMonth,
              bDay,
              bHour,
              bMinute,
              bSecond
            );
            return bDate - aDate;
          });
        }
        return this.searchFilterTimers.sort((a, b) => {
          const [
            aYear,
            aMonth,
            aDay,
            aHour,
            aMinute,
            aSecond,
          ] = a.widget.endDateTime.split(/[-,T,:]+/);
          const [
            bYear,
            bMonth,
            bDay,
            bHour,
            bMinute,
            bSecond,
          ] = b.widget.endDateTime.split(/[-,T,:]+/);
          const aDate = new Date(
            aYear,
            parseInt(aMonth) - 1,
            aDay,
            aHour,
            aMinute,
            aSecond
          );
          const bDate = new Date(
            bYear,
            parseInt(bMonth) - 1,
            bDay,
            bHour,
            bMinute,
            bSecond
          );
          return aDate - bDate;
        });
      }
      if (this.sortBy === "time zone") {
        if (this.sortDirection === "ascending") {
          return this.searchFilterTimers.sort((a, b) => {
            if (
              a.endTimeZoneInfoFormatted.toLowerCase() >
              b.endTimeZoneInfoFormatted.toLowerCase()
            ) {
              return -1;
            }
            if (a.endTimeZoneInfoFormatted < b.endTimeZoneInfoFormatted) {
              return 1;
            }
            return 0;
          });
        }
        return this.searchFilterTimers.sort((a, b) => {
          if (
            a.endTimeZoneInfoFormatted.toLowerCase() <
            b.endTimeZoneInfoFormatted.toLowerCase()
          ) {
            return -1;
          }
          if (
            a.endTimeZoneInfoFormatted.toLowerCase() >
            b.endTimeZoneInfoFormatted.toLowerCase()
          ) {
            return 1;
          }
          return 0;
        });
      }
      return this.searchFilterTimers;
    },
    // final list of timers passed to the gallery / list component
    timersToDisplay: function() {
      if (this.numberOfTimers > 0 || this.viewType === "gallery") {
        return this.sortTimers.slice(
          this.firstTimerOnPage - 1,
          this.lastTimerOnPage
        );
      }
      return this.sortTimers;
    },
    /**
     * selected sort method is based on router query
     * when user selects a new sort method, the router query is updated
     */
    sortSelected: {
      get: function() {
        const option = this.sortOptions.find(
          o =>
            o.sortBy === this.sortBy && o.sortDirection === this.sortDirection
        );
        if (option) {
          return option.value;
        }
        return "";
      },
      set: function(newValue) {
        const option = this.sortOptions.find(o => o.value === newValue);
        this.setTimerSortSelected(newValue);
        if (option) {
          this.$router.push({
            name: "dashboard overview",
            query: this.getRouterQuery({
              sortBy: option.sortBy,
              sortDirection: option.sortDirection,
            }),
          });

          this.pageNumber = 1;
        }
      },
    },
    // the string being searched
    searchValue: {
      get: function() {
        if (this.$route.query.search) {
          return this.$route.query.search;
        }
        return "";
      },
      set: function(newValue) {
        this.$router.push({
          name: "dashboard overview",
          query: this.getRouterQuery({ search: newValue }),
        });
      },
    },
    numberOfTimers: {
      get: function() {
        if (
          this.$route.query.numberOfTimers ||
          this.$route.query.numberOfTimers === 0
        ) {
          return parseInt(this.$route.query.numberOfTimers);
        }
        return this.defaultValues.defaultNumberOfTimers;
      },
      set: function(newValue) {
        this.$router.push({
          name: "dashboard overview",
          query: this.getRouterQuery({
            numberOfTimers: newValue,
            pageNumber: 1,
          }),
        });
      },
    },
    pageNumber: {
      get: function() {
        if (this.$route.query.pageNumber) {
          return this.$route.query.pageNumber;
        }
        return 1;
      },
      set: function(newValue) {
        this.$router.push({
          name: "dashboard overview",
          query: this.getRouterQuery({
            pageNumber: newValue,
          }),
        });
      },
    },
    // total number of pages
    numberOfPages: function() {
      if (this.numberOfTimers > 0) {
        return Math.ceil(this.sortTimers.length / this.numberOfTimers);
      }
      return 1;
    },
    // the number for the first timer on the page being viewed
    firstTimerOnPage: function() {
      const firstTimer = (this.pageNumber - 1) * this.numberOfTimers + 1;
      if (firstTimer < this.sortTimers.length) {
        return firstTimer;
      }
      return this.sortTimers.length;
    },
    // number for the last timer on the page being viewed
    lastTimerOnPage: function() {
      if (this.numberOfTimers > 0) {
        const lastTimer =
          (this.pageNumber - 1) * this.numberOfTimers + this.numberOfTimers;
        if (lastTimer < this.sortTimers.length) {
          return lastTimer;
        }
        return this.sortTimers.length;
      }
      return this.sortTimers.length;
    },
  },
  methods: {
    ...mapMutations("account", ["setTimerSortSelected"]),
    openTimerCodeModal: function(code) {
      this.$modal.show(TimerCode, { code, modal: true });
    },
    /**
     * takes an object with any number of new router query values
     * and returns a new object with all the router query values
     * needed to tell the table how to sort and search
     */
    getRouterQuery: function(newValues) {
      const {
        timerType,
        viewType,
        sortBy,
        sortDirection,
        search,
        numberOfTimers,
        pageNumber,
      } = {
        timerType: this.timerType,
        viewType: this.viewType,
        sortBy: this.sortBy,
        sortDirection: this.sortDirection,
        search: this.searchValue,
        numberOfTimers: this.numberOfTimers,
        pageNumber: this.pageNumber,
        ...newValues,
      };
      return {
        timerType,
        viewType,
        sortBy,
        sortDirection,
        search,
        numberOfTimers,
        pageNumber,
      };
    },
    nextPage: function() {
      if (this.pageNumber < this.numberOfPages) {
        this.$router.push({
          name: "dashboard overview",
          query: this.getRouterQuery({
            pageNumber: this.pageNumber + 1,
          }),
        });
      }
    },
    previousPage: function() {
      if (this.pageNumber > 1) {
        this.$router.push({
          name: "dashboard overview",
          query: this.getRouterQuery({
            pageNumber: this.pageNumber - 1,
          }),
        });
      }
    },
  },
};
</script>

<style></style>
